import { SVGProps, Ref, forwardRef } from 'react';

export const StarCircleFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 1c8.25 0 11 5.5 11 11s-2.75 11-11 11S1 17.5 1 12 3.75 1 12 1m0 4.5c-.696 0-1.106 1.03-1.927 3.089l-.182.458-.453.038c-2.125.18-3.189.27-3.404.96-.215.693.595 1.419 2.214 2.871l.328.294-.106.467c-.494 2.17-.74 3.255-.178 3.682s1.474-.153 3.295-1.314l.4-.255.4.255c1.821 1.161 2.732 1.742 3.295 1.314s.316-1.513-.178-3.682l-.102-.447.35-.314c1.62-1.452 2.429-2.178 2.214-2.87-.215-.691-1.279-.781-3.405-.961l-.452-.038-.182-.458C13.107 6.529 12.696 5.5 12 5.5"
                fill="currentColor"
            />
        </g>
    </svg>
));
StarCircleFilledSize24Glyph.displayName = 'StarCircleFilledSize24Glyph';
